// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1PasswordUpdateSchema } from './v1/password/updateSchema';

export const patchUserPasswordHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string().describe("Bearer token")),
});

/**
 * @description password updated successfully
 */
export const patchUserPassword200Schema = z.object({
  notice: z.optional(z.object({
    message: z.optional(z.coerce.string()),
  })),
  status: z.optional(z.coerce.string()),
});

/**
 * @description unauthorized
 */
export const patchUserPassword401Schema = z.unknown();

/**
 * @description validation errors
 */
export const patchUserPassword422Schema = z.object({
  errors: z.optional(z.object({})),
});

export const patchUserPasswordMutationRequestSchema = z.lazy(() => v1PasswordUpdateSchema);

export const patchUserPasswordMutationResponseSchema = z.lazy(() => patchUserPassword200Schema);
